import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Loading from '../../components/Loading';
import { MessageBox } from '../../components/MessageBox';
import { useMessageBox } from '../../context/MessageBox';
import api from '../../services/api';
import { handleErrorRequest } from '../../utils/errorsValidation';
import ApproveEmail from './ApproveEmail';
import RefuseEmail from './RefuseEmail';
import * as S from './styles';

export function ConclusionInterestEmails() {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const param = params.get('p');

    const [conclusionData, setConclusionData] = useState({});
    const [noData, setNoData] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const { setMessageData } = useMessageBox();

    const [isLoading, setIsLoading] = useState(true);

    const fetchConclusion = async () => {
        setIsLoading(true);
        try {
            const response = await api.get(
              `OperacoesEmailsInteresses/ConsultarParametrosLinkPaginaConclusao?parametros=${param}`,
            );
            setMessageData(response.data?.complemento?.mensagensBox);
            if(response.data?.resposta.length > 0) {
                setNoData(true)
            } else {
                setConclusionData(response.data.resposta)
                document.title = response.data.resposta.tituloAbaBrowser
                if (response.data.resposta.conclusao == 'Indisponivel' ) {
                    setResponseMessage(response.data.resposta.mensagem)
                }
            }

        } catch (e) {
            setNoData(true)
            toast.error(e.response);
        } finally {
            setIsLoading(false);
        }

    };

    useEffect(() => {
        fetchConclusion();
        document.title = 'Mesa de Antecipação';
        const link = document.querySelector('link[rel="icon"]');
        link.href = '/app/PaginaConclusao.ico';
    }, []);

    if (isLoading) {
        return (
        <S.LoaderContainer>
            <Loading />
        </S.LoaderContainer>
        );
    }

    if (noData) {
        return (
        <S.LoaderContainer>
            <h1>Servidor em manutenção</h1>
            <h2>Tente novamente mais tarde</h2>
        </S.LoaderContainer>
        );
    }

    return (
        <S.Container>
        <S.Header>
            <img src={conclusionData?.logotipoLink} alt="" />
        </S.Header>
        {responseMessage ? (
            <S.InfoContainer>
                <S.ResponseMessage dangerouslySetInnerHTML={{ __html: responseMessage }} />
            </S.InfoContainer>
        ) : (
            <>
                {conclusionData.conclusao == 'Aprovada' && (
                    <ApproveEmail data={conclusionData} setResponseMessage={setResponseMessage}/>
                )}
                {conclusionData.conclusao == 'Recusada' && (
                    <RefuseEmail data={conclusionData} setResponseMessage={setResponseMessage}/>
                )}
            </>
        )}
        </S.Container>
    );
}
